import { observer } from "mobx-react-lite";
import { ActivityDetailsItem } from "../../../ActivityDetailsItem/ActivityDetailsItem";
import { useActionDetails } from "../../hooks/useActionDetails";
import type { ActionGroupProps } from "../../types";
import { ActionDetailsContainer } from "../common/ActionDetailsContainer";
import { WithFindWrapper } from "../common/WithFindWrapper/WithFindWrapper";
import { OutputFields } from "./OutputFields";
import { RecordLink } from "./RecordLink";
import { DeleteInfoList } from "./style";
import { getFilteredOutputs, getOutputs, getRecordId } from "./utils";
import { findOutputValueAndLabel } from "../../../../utils";

export const DeleteLoopingRecordsGroup = observer<ActionGroupProps>(
  ({
    action,
    recordJobData,
    recordJobDataByDetailsId,
    recordJobIds,
    onDetailsClick,
    onRecordClick,
  }) => {
    const { status, errorMessage, actionLabel } = useActionDetails(action);

    return (
      <ActionDetailsContainer
        label={actionLabel}
        status={status}
        errorMessage={errorMessage}
        onDetailsClick={onDetailsClick}
      >
        <WithFindWrapper
          recordJobData={recordJobData}
          recordJobDataByDetailsId={recordJobDataByDetailsId}
          recordJobIds={recordJobIds}
          onRecordClick={onRecordClick}
        >
          {({ recordJobData }) => {
            const outputs = getOutputs(recordJobData);
            const filteredOutputs = getFilteredOutputs(outputs);
            const recordId = getRecordId(outputs);
            const applicationId = findOutputValueAndLabel(
              "application_id",
              outputs,
            );
            const solutionId = findOutputValueAndLabel("solution_id", outputs);
            return (
              <DeleteInfoList>
                <li>
                  <ActivityDetailsItem label="Deleted Record Id">
                    <RecordLink
                      recordId={recordId}
                      solutionId={solutionId}
                      applicationId={applicationId}
                    />
                  </ActivityDetailsItem>
                </li>

                <li>
                  <OutputFields
                    outputs={filteredOutputs.filter(
                      (output) => output.outputId !== "record_id",
                    )}
                  />
                </li>
              </DeleteInfoList>
            );
          }}
        </WithFindWrapper>
      </ActionDetailsContainer>
    );
  },
);
